import { DateModel } from './types';

export const EmptyDate = (name = ''): DateModel => ({
  day: '',
  estimated: false,
  month: '',
  name,
  year: '',
});

export const EmptyDateInstance = EmptyDate();
